import React, { Fragment, useState } from 'react';
import { Table } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { array, string, number } from 'prop-types';
import OfferLandingsTableItem from './OfferLandingsTableItem';
import { currencyToSign } from '../../utils/utils';
import cn from 'classnames';

const propTypes = {
  landings: array.isRequired,
  name: string.isRequired,
  currency: string.isRequired,
  topItem: number,
};

const defaultProps = {
  landings: [],
};

const OfferLandingsTable = ({
  hover,
  landings,
  name,
  currency,
  offer,
  site_key,
  connectOffer,
  topItem,
}) => {
  const {
    modifies: { is_cdn, g },
  } = offer;

  // find landing with max Cr to attach tag to
  const maxCrLanding =
    landings &&
    landings.reduce(
      (acc, v) => {
        return acc.totalCr < v.totalCr ? v : acc;
      },
      { totalCr: 0, id: -1 },
    );

  // Состояние для отслеживания порядка сортировки по имени
  const [nameSortOrder, setNameSortOrder] = useState('asc');
  // Состояние для отслеживания порядка сортировки по totalCr
  const [crSortOrder, setCrSortOrder] = useState('asc');
  // Состояние для отслеживания порядка сортировки по totalEpC
  const [epcSortOrder, setEpcSortOrder] = useState('asc');
  // Состояние для отслеживания отсортированных данных
  const [sortedLandings, setSortedLandings] = useState([...landings]);

  // Обработчик клика для изменения порядка сортировки по имени
  const handleNameSortClick = () => {
    const newSortOrder = nameSortOrder === 'asc' ? 'desc' : 'asc';

    const sorted = [...sortedLandings].sort((b, a) => {
      if (newSortOrder === 'asc') {
        return a.title.localeCompare(b.title);
      } else {
        return b.title.localeCompare(a.title);
      }
    });

    setNameSortOrder(newSortOrder);
    setSortedLandings(sorted);
  };

  // Обработчик клика для изменения порядка сортировки по totalCr
  const handleCrSortClick = () => {
    const newSortOrder = crSortOrder === 'asc' ? 'desc' : 'asc';

    const sorted = [...sortedLandings].sort((a, b) => {
      if (newSortOrder === 'asc') {
        return a.totalCr - b.totalCr;
      } else {
        return b.totalCr - a.totalCr;
      }
    });

    setCrSortOrder(newSortOrder);
    setSortedLandings(sorted);
  };

  // Обработчик клика для изменения порядка сортировки по totalEpC
  const handleEpcSortClick = () => {
    const newSortOrder = epcSortOrder === 'asc' ? 'desc' : 'asc';

    const sorted = [...sortedLandings].sort((a, b) => {
      if (newSortOrder === 'asc') {
        return a.totalEpC - b.totalEpC;
      } else {
        return b.totalEpC - a.totalEpC;
      }
    });

    setEpcSortOrder(newSortOrder);
    setSortedLandings(sorted);
  };

  return (
    <Fragment>
      <Table hover={hover} className="offer-landings-table no-margin" responsive bordered>
        <thead>
          <tr>
            <th className="platform">Ус-во</th>
            <th>
              <button className="offer-subtitle offer-subtitle-name" onClick={handleNameSortClick}>
                <FormattedMessage id="offer.landings-table.title" defaultMessage="Title" />{' '}
                <span
                  className={cn('sorting-icons-offers', {
                    asc: nameSortOrder === 'asc',
                    desc: nameSortOrder === 'desc',
                  })}
                />
              </button>
            </th>

            {!g && (
              <>
                <th className="values text-right">
                  <button className="offer-subtitle" onClick={handleCrSortClick}>
                    CR, %{' '}
                    <span
                      className={cn('sorting-icons-offers', {
                        asc: crSortOrder === 'asc',
                        desc: crSortOrder === 'desc',
                      })}
                    />
                  </button>
                </th>
                <th className="values text-right">
                  <button className="offer-subtitle" onClick={handleEpcSortClick}>
                    EPC, {currencyToSign(currency)}{' '}
                    <span
                      className={cn('sorting-icons-offers', {
                        asc: epcSortOrder === 'asc',
                        desc: epcSortOrder === 'desc',
                      })}
                    />
                  </button>
                </th>
              </>
            )}
            <th />
            {is_cdn ? <th>{''}</th> : null}
          </tr>
        </thead>
        <tbody>
          {sortedLandings.length > 0 &&
            sortedLandings.map((landing) => (
              <OfferLandingsTableItem
                key={landing.id}
                name={name}
                {...landing}
                offer={offer}
                connectOffer={connectOffer}
                site_key={site_key}
                isTop={topItem === landing.id}
                maxCrLandingId={maxCrLanding.id}
              />
            ))}
        </tbody>
      </Table>
    </Fragment>
  );
};

OfferLandingsTable.propTypes = propTypes;
OfferLandingsTable.defaultProps = defaultProps;

export default OfferLandingsTable;
